import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'signin-field_change-keyboard_input';
/**
 * capture field name change
 */ export function trackSigninFieldChangeKeyboardInput(field_name_string, value_string2, sign_in_viewstring3) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            field_name_string: field_name_string,
            value_string2: value_string2,
            sign_in_viewstring3: sign_in_viewstring3
        }
    });
}
